import React, { CSSProperties } from 'react'

import { EthereumIcon, PulseChainIcon } from '~public'

/** Square token mark in Buy/Sell/Transactions tables. */
export const TOKEN_LOGO: CSSProperties = {
  height: 24,
  width: 24,
  objectFit: 'contain',
  margin: 0,
}

/** PulseChain PNG has extra padding, so it is drawn slightly larger than Ethereum. */
export const NetworkLogo = ({ isEth }: { isEth: boolean }) => (
  <span
    title={isEth ? 'Ethereum' : 'PulseChain'}
    style={{
      display: 'inline-flex',
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    }}
  >
    {isEth ? <EthereumIcon style={{ height: 22, width: 22 }} /> : <PulseChainIcon style={{ height: 28, width: 28 }} />}
  </span>
)
